module.exports = __webpack_public_path__ + "static/media/img110_R.0de9e438.jpg";